export default "__VITE_ASSET__CeHASZYU__"